module.exports = __webpack_public_path__ + "img/clube1.c0bb00d1.jpeg";